import {ChangeDetectorRef, Component, ElementRef, Inject, Input, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';
import {UploadService} from '@shared/services/upload.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {BLOCKS_CONFIG, BlocksConfig} from '../blocks.config';
import {BlockMutationService} from '@blocks/services/block-mutation/block-mutation.service';
import {BlockComponent} from '@blocks/block/block.component';
import {UploadBlockComponent} from '@blocks/upload/upload.component';
import {SessionStore} from '../../submission/src/app/session/session.store';
import {ToastService} from '@paperlessio/sdk/api/util';
import {Attachment, BlockType, Button} from '@paperlessio/sdk/api/models';
import {Helper} from '@paperlessio/sdk/util/helpers';

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent extends UploadBlockComponent implements OnInit, OnDestroy {
  @ViewChild('file') file: ElementRef;
  @Input() block: Attachment;

  public legacyFakeButton: Button;

  constructor(
    protected uploadService: UploadService,
    protected blockMutationService: BlockMutationService,
    protected toast: ToastService,
    protected cdr: ChangeDetectorRef,
    private http: HttpClient,
    @Optional() private sessionStore: SessionStore,
    @Inject(BLOCKS_CONFIG) public blocksConfig: BlocksConfig,
    @Optional() public blockComponent: BlockComponent
  ) {
    super(uploadService, blockMutationService, toast, cdr);
  }

  ngOnInit() {
    if (this.block.styles.format === 'button') {
      this.handleLegacyMode();
    }

    super.init();
  }

  ngOnDestroy(): void {
    super.destroy();
  }

  public onFile(file: File): void {
    this.block.settings.name = file.name;
    this.block.settings.size = file.size;
    this.block.settings.type = file.type;
    this.block.settings.label = file.name;
    super.onFile(file);
  }

  public onDownload(): void {
    if (this.blocksConfig.interactive || this.blocksConfig.editable) {
      this.http.get(this.block.file.url, {responseType: 'blob'}).pipe(
        map(res => new Blob([res]))
      ).subscribe(blob => {
        Helper.downloadFile(blob, this.block.file.filename);
        this.trackDownload();
      });
    }
  }

  public trackDownload() {
    if (this.sessionStore) {
      this.sessionStore.createAttachmentDownloadedActivityEvent(this.block.id).subscribe();
    }
  }

  private handleLegacyMode() {
    // legacy compat
    this.legacyFakeButton = new Button(Object.assign((this.block.settings as any).fakeButton ??
      new Button(), {type: BlockType.Button}));
  }
}
